import Image, { ImageProps } from 'next/image'
import { FunctionComponent, useMemo } from 'react'
import { useI18n } from '@/hooks/use-i18n'
import { SupportedLanguages } from '@/i18n/config'

export interface LocalizedFutureImageProps extends ImageProps {
  enSrc?: string | StaticImageData
  zhHantSrc?: string | StaticImageData
  jaSrc?: string | StaticImageData
}

const LocalizedImage: FunctionComponent<LocalizedFutureImageProps> = ({
  alt,
  src,
  enSrc,
  zhHantSrc,
  jaSrc,
  ...props
}) => {
  const { language } = useI18n()

  const imageSrc = useMemo(() => {
    const localeMap: Record<
      SupportedLanguages,
      string | StaticImageData | undefined
    > = {
      [SupportedLanguages.enUS]: enSrc,
      [SupportedLanguages.zhTW]: zhHantSrc,
      [SupportedLanguages.ja]: jaSrc,
      [SupportedLanguages.ach]: enSrc,
    }
    return localeMap[language.i18nCode] ?? src
  }, [language.i18nCode, enSrc, zhHantSrc, jaSrc, src])

  return <Image alt={alt} src={imageSrc} {...props} />
}

export default LocalizedImage
